<button class="btn btn-sm btn-secondary" (click)="sendMessageClick()">
  <span [hidden]="sendingMessage">Send Test Message</span>
  <span [hidden]="!sendingMessage">
    <fa-icon [icon]="['fas', 'circle-notch']" size="sm" [spin]="true" /> Sending...
  </span>
</button>
<p *ngIf="errorMessage" class="text-danger small my-2">
  {{ errorMessage }}
</p>
